<template>
  <div ref="homeContainer" class="home-page">

    <!-- ==================== 学员首页 ==================== -->
    <template v-if="identity === 'student'">
      <!-- 学员个人信息卡片 -->
      <div class="stu-profile-card">
        <div class="stu-profile-avatar">
          <el-icon :size="36" color="#fff"><User /></el-icon>
        </div>
        <div class="stu-profile-info">
          <div class="stu-profile-name">{{ stuInfo.name || '学员' }}</div>
          <div class="stu-profile-meta">
            <span v-if="stuInfo.class_num" class="stu-profile-tag">{{ stuInfo.class_num }}</span>
            <span v-if="stuInfo.dormRoom" class="stu-profile-room">
              {{ stuInfo.dormRoom.dormBuildId + '-' + stuInfo.dormRoom.dormRoomId }}
            </span>
            <span v-else class="stu-profile-room" style="color:#999">未分配房间</span>
          </div>
        </div>
      </div>

      <!-- 快捷功能入口 -->
      <div class="stu-shortcuts">
        <div class="stu-shortcut-item" @click="goLink(10)">
          <div class="stu-shortcut-icon stu-shortcut-icon-1">
            <el-icon :size="24"><HomeFilled /></el-icon>
          </div>
          <span>我的宿舍</span>
        </div>
        <div class="stu-shortcut-item" @click="goLink(11)">
          <div class="stu-shortcut-icon stu-shortcut-icon-4">
            <el-icon :size="24"><SetUp /></el-icon>
          </div>
          <span>报修申请</span>
        </div>
        <div class="stu-shortcut-item" @click="goLink(12)">
          <div class="stu-shortcut-icon stu-shortcut-icon-5">
            <el-icon :size="24"><Promotion /></el-icon>
          </div>
          <span>申请调宿</span>
        </div>
        <div class="stu-shortcut-item" @click="goLink(13)">
          <div class="stu-shortcut-icon stu-shortcut-icon-6">
            <el-icon :size="24"><User /></el-icon>
          </div>
          <span>个人信息</span>
        </div>
      </div>

      <!-- 宿舍通告 -->
      <el-card class="section-card stu-section-card">
        <template #header>
          <div class="section-header">
            <span class="section-title">宿舍通告</span>
          </div>
        </template>
        <div class="notice-list">
          <div v-for="(activity, index) in activities.slice(0, 5)" :key="index" class="notice-item" @click="viewNoticeDetail(activity)">
            <span class="notice-dot"></span>
            <span class="notice-title">{{ activity.title }}</span>
            <span class="notice-time">{{ formatShortTime(activity.createTime) }}</span>
          </div>
          <div v-if="activities.length === 0" class="empty-block">
            <el-icon :size="28" color="#dcdfe6"><Bell /></el-icon>
            <span>暂无通告</span>
          </div>
        </div>
      </el-card>

      <!-- 退房提醒 -->
      <el-card class="section-card stu-section-card">
        <template #header>
          <div class="section-header">
            <span class="section-title">退房提醒</span>
            <el-tag v-if="stuInfo.class_num" type="info" size="small">{{ stuInfo.class_num }}</el-tag>
          </div>
        </template>
        <div v-if="studentCheckoutReminders.hasReminder" class="stu-reminder-block">
          <div class="stu-reminder-info">
            <el-icon :size="20" color="#e6a23c"><Bell /></el-icon>
            <span>您的班级 <b>{{ stuInfo.class_num }}</b> 将于 <b>{{ studentCheckoutReminders.leaveDate }}</b> 退房</span>
          </div>
          <div v-if="studentCheckoutReminders.isToday" class="stu-reminder-urgency today">
            今日退房，请及时整理行李
          </div>
          <div v-else-if="studentCheckoutReminders.isTomorrow" class="stu-reminder-urgency tomorrow">
            明日退房，请提前整理
          </div>
          <div v-else class="stu-reminder-urgency week">
            本周退房，请提前准备
          </div>
        </div>
        <div v-else class="empty-block">
          <el-icon :size="28" color="#dcdfe6"><Calendar /></el-icon>
          <span>暂无退房提醒</span>
        </div>
      </el-card>
    </template>

    <!-- ==================== 管理员/宿管首页 ==================== -->
    <template v-else>
    <!-- 全屏按钮 -->
    <div class="fullscreen-btn-wrapper">
      <el-button :icon="isFullscreen ? 'Aim' : 'FullScreen'" type="default" @click="toggleFullscreen" circle size="small" />
    </div>

    <!-- 统计卡片 -->
    <div class="stats-row">
      <div class="stat-card stat-card-1" @click="goLink(1)">
        <div class="stat-icon">
          <el-icon :size="28"><User /></el-icon>
        </div>
        <div class="stat-content">
          <div class="stat-value">{{ studentNum }}</div>
          <div class="stat-label">学员总数</div>
        </div>
      </div>
      <div class="stat-card stat-card-2" @click="goLink(2)">
        <div class="stat-icon">
          <el-icon :size="28"><HomeFilled /></el-icon>
        </div>
        <div class="stat-content">
          <div class="stat-value">{{ haveRoomStudentNum }}</div>
          <div class="stat-label">住宿人数</div>
        </div>
      </div>
      <div class="stat-card stat-card-3" @click="goLink(3)">
        <div class="stat-icon">
          <el-icon :size="28"><SetUp /></el-icon>
        </div>
        <div class="stat-content">
          <div class="stat-value">{{ repairOrderNum }}</div>
          <div class="stat-label">报修工单</div>
        </div>
      </div>
      <div class="stat-card stat-card-4" @click="goLink(4)">
        <div class="stat-icon">
          <el-icon :size="28"><House /></el-icon>
        </div>
        <div class="stat-content">
          <div class="stat-value">{{ emptyRoomNum }}</div>
          <div class="stat-label">空房数量</div>
        </div>
      </div>
      <div class="stat-card stat-card-panel" @click="goPanel">
        <div class="stat-icon">
          <el-icon :size="28"><Grid /></el-icon>
        </div>
        <div class="stat-content">
          <div class="stat-label">房间面板</div>
          <div class="stat-link">查看全部房态 &rarr;</div>
        </div>
      </div>
      <div class="stat-card stat-card-calendar" @click="goRoomCalendar">
        <div class="stat-icon">
          <el-icon :size="28"><Calendar /></el-icon>
        </div>
        <div class="stat-content">
          <div class="stat-label">日历视图</div>
          <div class="stat-link">查看房态日历 &rarr;</div>
        </div>
      </div>
    </div>

    <!-- 主区域 -->
    <div class="main-area">
      <div class="main-left">
        <!-- 图表 -->
        <el-card class="section-card chart-section">
          <template #header>
            <div class="section-header">
              <span class="section-title">宿舍学员人数分布</span>
            </div>
          </template>
          <home_echarts />
        </el-card>
        <!-- 通告 -->
        <el-card class="section-card notice-section">
          <template #header>
            <div class="section-header">
              <span class="section-title">宿舍通告</span>
            </div>
          </template>
          <div class="notice-list">
            <div v-for="(activity, index) in activities.slice(0, 5)" :key="index" class="notice-item" @click="viewNoticeDetail(activity)">
              <span class="notice-dot"></span>
              <span class="notice-title">{{ activity.title }}</span>
              <span class="notice-time">{{ formatShortTime(activity.createTime) }}</span>
            </div>
            <div v-if="activities.length === 0" class="empty-block">
              <el-icon :size="28" color="#dcdfe6"><Bell /></el-icon>
              <span>暂无通告</span>
            </div>
          </div>
        </el-card>
      </div>

      <div class="main-right">
        <!-- 退房提醒（合并为一个卡片，折叠面板） -->
        <el-card class="section-card reminder-section">
          <template #header>
            <div class="section-header">
              <span class="section-title">退房提醒</span>
              <el-button type="primary" link size="small" @click="goRoomCalendar">
                日历视图<el-icon class="el-icon--right"><ArrowRight /></el-icon>
              </el-button>
            </div>
          </template>
          <el-collapse v-model="activeCollapse" class="reminder-collapse">
            <el-collapse-item name="today">
              <template #title>
                <div class="collapse-title">
                  <span class="collapse-title-text">今日退房</span>
                  <el-tag type="danger" size="small" effect="dark">{{ checkoutReminders.todayCount || 0 }}个</el-tag>
                </div>
              </template>
              <div v-if="checkoutReminders.todayCheckout && checkoutReminders.todayCheckout.length > 0" class="reminder-list-inner">
                <div v-for="(item, index) in checkoutReminders.todayCheckout.slice(0, 6)" :key="'td'+index" class="reminder-row">
                  <div class="reminder-row-left">
                    <el-tag :color="item.classColor" style="color:#fff;border:none;" size="small">{{ item.className }}</el-tag>
                    <span class="reminder-row-num">{{ item.type === 'checkedIn' ? item.studentCount + '人' : item.bedsCount + '床' }}</span>
                  </div>
                  <span class="reminder-row-date">{{ formatShortDate(item.leaveDate) }}</span>
                </div>
              </div>
              <div v-else class="empty-block small">
                <el-icon :size="24" color="#dcdfe6"><Calendar /></el-icon>
                <span>今日无退房安排</span>
              </div>
            </el-collapse-item>
            <el-collapse-item name="tomorrow">
              <template #title>
                <div class="collapse-title">
                  <span class="collapse-title-text">明日退房</span>
                  <el-tag type="warning" size="small" effect="dark">{{ checkoutReminders.tomorrowCount || 0 }}个</el-tag>
                </div>
              </template>
              <div v-if="checkoutReminders.tomorrowCheckout && checkoutReminders.tomorrowCheckout.length > 0" class="reminder-list-inner">
                <div v-for="(item, index) in checkoutReminders.tomorrowCheckout.slice(0, 6)" :key="'tm'+index" class="reminder-row">
                  <div class="reminder-row-left">
                    <el-tag :color="item.classColor" style="color:#fff;border:none;" size="small">{{ item.className }}</el-tag>
                    <span class="reminder-row-num">{{ item.type === 'checkedIn' ? item.studentCount + '人' : item.bedsCount + '床' }}</span>
                  </div>
                  <span class="reminder-row-date">{{ formatShortDate(item.leaveDate) }}</span>
                </div>
              </div>
              <div v-else class="empty-block small">
                <el-icon :size="24" color="#dcdfe6"><Calendar /></el-icon>
                <span>明日无退房安排</span>
              </div>
            </el-collapse-item>
            <el-collapse-item name="week">
              <template #title>
                <div class="collapse-title">
                  <span class="collapse-title-text">本周退房</span>
                  <el-tag type="info" size="small" effect="dark">{{ checkoutReminders.weekCount || 0 }}个</el-tag>
                </div>
              </template>
              <div v-if="checkoutReminders.weekCheckout && checkoutReminders.weekCheckout.length > 0" class="reminder-list-inner">
                <div v-for="(item, index) in checkoutReminders.weekCheckout.slice(0, 6)" :key="'wk'+index" class="reminder-row">
                  <div class="reminder-row-left">
                    <el-tag :color="item.classColor" style="color:#fff;border:none;" size="small">{{ item.className }}</el-tag>
                    <span class="reminder-row-num">{{ item.type === 'checkedIn' ? item.studentCount + '人' : item.bedsCount + '床' }}</span>
                  </div>
                  <span class="reminder-row-date">{{ formatShortDate(item.leaveDate) }}</span>
                </div>
              </div>
              <div v-else class="empty-block small">
                <el-icon :size="24" color="#dcdfe6"><Calendar /></el-icon>
                <span>本周无退房安排</span>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-card>
      </div>
    </div>
    </template>

    <!-- 通告详情弹窗 -->
    <el-dialog v-model="noticeDetailVisible" title="通告详情" width="500px" :close-on-click-modal="false">
      <div v-if="currentNotice" class="notice-detail">
        <h3 class="notice-detail-title">{{ currentNotice.title }}</h3>
        <div class="notice-detail-meta">
          <span>发布时间：{{ formatShortTime(currentNotice.createTime) }}</span>
          <span v-if="currentNotice.adminName">发布人：{{ currentNotice.adminName }}</span>
        </div>
        <div class="notice-detail-content" v-html="currentNotice.content"></div>
      </div>
      <template #footer>
        <el-button @click="noticeDetailVisible = false">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";
import home_echarts from "@/components/home_echarts";
import { ElMessage } from 'element-plus';

export default {
  name: "Home",
  components: {
    home_echarts,
  },
  data() {
    return {
      studentNum: "",
      haveRoomStudentNum: "",
      repairOrderNum: "",
      noFullRoomNum: "",
      emptyRoomNum: "",
      activities: [],
      identity: "",
      isFullscreen: false,
      activeCollapse: ['today', 'tomorrow', 'week'],
      checkoutReminders: {
        todayCheckout: [],
        tomorrowCheckout: [],
        weekCheckout: [],
        todayCount: 0,
        tomorrowCount: 0,
        weekCount: 0
      },
      noticeDetailVisible: false,
      currentNotice: null,
      stuInfo: {},
    };
  },
  created() {
    this.identity = window.sessionStorage.getItem("identity");
    if (this.identity === 'student') {
      this.loadStuInfo();
      this.getHomePageNotice();
      this.getTodayReminders();
    } else {
      this.getHomePageNotice();
      this.getStuNum();
      this.getHaveRoomNum();
      this.getOrderNum();
      this.getNoFullRoom();
      this.getStatistics();
      this.getTodayReminders();
    }
    document.addEventListener("fullscreenchange", this.handleFullscreenChange);
  },
  beforeUnmount() {
    document.removeEventListener("fullscreenchange", this.handleFullscreenChange);
  },
  computed: {
    studentCheckoutReminders() {
      const empty = { hasReminder: false, isToday: false, isTomorrow: false, leaveDate: '' };
      if (!this.stuInfo || !this.stuInfo.class_num) return empty;
      const className = this.stuInfo.class_num;
      const todayMatch = (this.checkoutReminders.todayCheckout || []).find(item => item.className === className);
      const tomorrowMatch = (this.checkoutReminders.tomorrowCheckout || []).find(item => item.className === className);
      const weekMatch = (this.checkoutReminders.weekCheckout || []).find(item => item.className === className);
      if (todayMatch) return { hasReminder: true, isToday: true, isTomorrow: false, leaveDate: todayMatch.leaveDate };
      if (tomorrowMatch) return { hasReminder: true, isToday: false, isTomorrow: true, leaveDate: tomorrowMatch.leaveDate };
      if (weekMatch) return { hasReminder: true, isToday: false, isTomorrow: false, leaveDate: weekMatch.leaveDate };
      return empty;
    }
  },
  methods: {
    toggleFullscreen() {
      const el = this.$refs.homeContainer || document.documentElement;
      if (!document.fullscreenElement) {
        el.requestFullscreen().then(() => { this.isFullscreen = true; }).catch((err) => {
          ElMessage({ message: "全屏失败: " + err.message, type: "error" });
        });
      } else {
        document.exitFullscreen().then(() => { this.isFullscreen = false; });
      }
    },
    handleFullscreenChange() { this.isFullscreen = !!document.fullscreenElement; },
    goRoomCalendar() { this.$router.push({ path: "/roomCalendar" }); },
    goPanel() { this.$router.push({ path: "/roomPanel" }); },
    async getTodayReminders() {
      request.get("/checkoutReminders").then((res) => {
        if (res.code === "0") { this.checkoutReminders = res.data; }
      }).catch(() => {
        this.checkoutReminders = { todayCheckout: [], tomorrowCheckout: [], weekCheckout: [], todayCount: 0, tomorrowCount: 0, weekCount: 0 };
      });
    },
    async getStatistics() {
      request.get("/room/find", { params: { pageNum: 1, pageSize: 9999, isCheckedIn: 0 } }).then((res) => {
        if (res.code === "0") { this.emptyRoomNum = res.data.total || 0; }
      });
    },
    async getStuNum() {
      request.get("/stu/stuNum").then((res) => {
        if (res.code === "0") { this.studentNum = res.data; }
      });
    },
    async getHaveRoomNum() {
      request.get("/room/selectHaveRoomStuNum").then((res) => {
        if (res.code === "0") { this.haveRoomStudentNum = res.data; }
      });
    },
    async getOrderNum() {
      request.get("/repair/orderNum").then((res) => {
        if (res.code === "0") { this.repairOrderNum = res.data; }
      });
    },
    async getNoFullRoom() {
      request.get("/room/noFullRoom").then((res) => {
        if (res.code === "0") { this.noFullRoomNum = res.data; }
      });
    },
    async getHomePageNotice() {
      request.get("/notice/homePageNotice").then((res) => {
        if (res.code === "0") { this.activities = res.data; }
      });
    },
    viewNoticeDetail(notice) {
      this.currentNotice = notice;
      this.noticeDetailVisible = true;
    },
    formatShortTime(t) {
      if (!t) return '';
      const d = new Date(t);
      if (isNaN(d.getTime())) return t;
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      const hh = String(d.getHours()).padStart(2, '0');
      const mi = String(d.getMinutes()).padStart(2, '0');
      return mm + '-' + dd + ' ' + hh + ':' + mi;
    },
    formatShortDate(t) {
      if (!t) return '';
      const d = new Date(t);
      if (isNaN(d.getTime())) return t;
      return (d.getMonth() + 1) + '/' + d.getDate();
    },
    loadStuInfo() {
      try {
        const userStr = window.sessionStorage.getItem("user");
        if (!userStr) return;
        const user = JSON.parse(userStr);
        // 直接赋值整个对象，保留 dormRoom 嵌套结构
        this.stuInfo = user;
        // 如果 dormRoom 为空，尝试从 API 获取最新房间信息
        if (user && user.username && (!user.dormRoom || !user.dormRoom.dormBuildId)) {
          this.refreshStuDormRoom(user.username);
        }
      } catch (e) {
        console.error('loadStuInfo error', e);
      }
    },
    async refreshStuDormRoom(username) {
      try {
        const request = require("@/utils/request").default;
        const res = await request.get("/room/getMyRoom/" + username);
        if (res.code === "0" && res.data) {
          this.stuInfo.dormRoom = {
            dormBuildId: res.data.dormBuildId,
            dormRoomId: res.data.dormRoomId
          };
          // 同步更新 sessionStorage
          const userStr = window.sessionStorage.getItem("user");
          if (userStr) {
            const userData = JSON.parse(userStr);
            userData.dormRoom = this.stuInfo.dormRoom;
            window.sessionStorage.setItem("user", JSON.stringify(userData));
          }
        }
      } catch (e) {
        console.error('refreshStuDormRoom error', e);
      }
    },
    goLink(type) {
      const map = {
        1: '/applyRepairInfo',
        2: '/applyChangeRoom',
        10: '/myRoomInfo',
        11: '/applyRepairInfo',
        12: '/applyChangeRoom',
        13: '/selfInfo',
      };
      if (map[type]) {
        this.$router.push({ path: map[type] });
      }
    },
  },
};
</script>

<style scoped>
/* ===== 首页整体 ===== */
.home-page {
  min-height: calc(100vh - 56px);
  background: #f0f2f5;
  padding: 12px 16px 16px;
}

.fullscreen-btn-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 8px;
}

/* ===== 统计卡片行 ===== */
.stats-row {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.stat-card {
  flex: 1;
  min-width: 120px;
  max-width: 220px;
  background: #fff;
  border-radius: 8px;
  padding: 16px 14px;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: transform 0.15s, box-shadow 0.15s;
  border: 1px solid #e8eaed;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}

.stat-icon {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.stat-card-1 .stat-icon { background: #e8f8f5; color: #1ACAA8; }
.stat-card-2 .stat-icon { background: #e6f4ff; color: #5783fe; }
.stat-card-3 .stat-icon { background: #f3e8ff; color: #9f5bda; }
.stat-card-4 .stat-icon { background: #fff3e0; color: #ff7f41; }
.stat-card-panel .stat-icon { background: #f0f9eb; color: #67C23A; }
.stat-card-calendar .stat-icon { background: #fdf6ec; color: #E6A23C; }

.stat-content {
  flex: 1;
  min-width: 0;
}

.stat-value {
  font-size: 24px;
  font-weight: 700;
  color: #1d2129;
  line-height: 1.2;
}

.stat-label {
  font-size: 13px;
  color: #86909c;
  line-height: 1.2;
  margin-top: 2px;
}

.stat-link {
  font-size: 13px;
  color: #00ab84;
  line-height: 1.2;
  margin-top: 2px;
}

/* ===== 主区域（两栏） ===== */
.main-area {
  display: flex;
  gap: 16px;
}

.main-left {
  flex: 3;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.main-right {
  flex: 2;
  min-width: 280px;
  max-width: 420px;
}

/* ===== 通用卡片 ===== */
.section-card {
  border-radius: 8px;
  border: 1px solid #e8eaed;
}
.stu-section-card {
  margin-bottom: 16px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 10px;
}

.section-title {
  font-size: 15px;
  font-weight: 600;
  color: #1d2129;
  position: relative;
}

.section-title::before {
  content: "";
  width: 4px;
  height: 16px;
  background: #00ab84;
  position: absolute;
  left: -10px;
  top: 2px;
  border-radius: 2px;
}

/* ===== 图表区 ===== */
.chart-section .el-card__body {
  padding: 10px 16px 16px;
}

/* ===== 通告列表 ===== */
.notice-list {
  padding-top: 4px;
}

.notice-item {
  display: flex;
  align-items: center;
  padding: 12px 4px;
  border-bottom: 1px solid #f2f3f5;
  cursor: pointer;
  transition: background 0.15s;
}

.notice-item:last-child { border-bottom: none; }
.notice-item:hover { background: #f5f7fa; }

.notice-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #00ab84;
  margin-right: 10px;
  flex-shrink: 0;
}

.notice-title {
  flex: 1;
  font-size: 14px;
  color: #1d2129;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.notice-item:hover .notice-title { color: #409eff; }

.notice-time {
  font-size: 12px;
  color: #86909c;
  margin-left: 12px;
  flex-shrink: 0;
}

/* ===== 空状态 ===== */
.empty-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 0;
  color: #86909c;
}

.empty-block.small { padding: 20px 0; }
.empty-block span { margin-top: 8px; font-size: 13px; }

/* ===== 退房提醒折叠面板 ===== */
.reminder-collapse {
  border: none;
}

.reminder-collapse .el-collapse-item__header {
  height: 44px;
  line-height: 44px;
  background: #fff;
  border-bottom: 1px solid #f2f3f5;
  padding: 0 8px;
}

.reminder-collapse .el-collapse-item__wrap {
  border-bottom: none;
}

.reminder-collapse .el-collapse-item__content {
  padding: 8px 0;
}

.collapse-title {
  display: flex;
  align-items: center;
  gap: 8px;
}

.collapse-title-text {
  font-size: 14px;
  font-weight: 500;
  color: #1d2129;
}

/* ===== 退房提醒列表 ===== */
.reminder-list-inner {
  max-height: 280px;
  overflow-y: auto;
}

.reminder-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 8px;
  border-bottom: 1px solid #f2f3f5;
}

.reminder-row:last-child { border-bottom: none; }

.reminder-row-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.reminder-row-num {
  font-size: 14px;
  color: #1d2129;
}

.reminder-row-date {
  font-size: 12px;
  color: #86909c;
}

/* ===== 通告详情弹窗 ===== */
.notice-detail { padding: 0 10px; }
.notice-detail-title {
  font-size: 18px; font-weight: 600; color: #303133;
  margin-bottom: 12px; padding-bottom: 12px;
  border-bottom: 1px solid #ebeef5;
}
.notice-detail-meta {
  display: flex; justify-content: space-between;
  font-size: 13px; color: #909399; margin-bottom: 16px;
}
.notice-detail-content {
  font-size: 14px; color: #606266;
  line-height: 1.8; word-break: break-word;
}
.notice-detail-content p { margin: 0 0 12px 0; }

/* ===== 响应式 ===== */
@media screen and (max-width: 768px) {
  .home-page { padding: 8px 10px 10px; }

  .stats-row { gap: 8px; }

  .stat-card {
    min-width: 100px;
    padding: 12px 10px;
  }

  .stat-icon { width: 36px; height: 36px; }
  .stat-icon .el-icon { font-size: 22px; }
  .stat-value { font-size: 20px; }
  .stat-label { font-size: 12px; }

  .main-area {
    flex-direction: column;
    gap: 12px;
  }

  .main-right {
    max-width: none;
    min-width: 0;
  }

  /* 手机版精简时间 */
  .notice-time {
    font-size: 11px;
    margin-left: 6px;
  }

  .reminder-row-date {
    font-size: 11px;
  }
}

@media screen and (max-width: 480px) {
  .stat-card { min-width: 80px; padding: 10px 8px; }
  .stat-icon { width: 32px; height: 32px; }
  .stat-icon .el-icon { font-size: 18px; }
  .stat-value { font-size: 18px; }
  .stat-link { font-size: 12px; }
}

/* ===== 全屏模式 ===== */
:fullscreen .home-page,
:-webkit-full-screen .home-page {
  padding: 10px 20px 20px;
}

:fullscreen .main-area,
:-webkit-full-screen .main-area {
  flex-wrap: nowrap;
}

/* ===== 学员首页 ===== */
.stu-home { padding: 0 12px 20px; }

.stu-profile-card {
  display: flex; align-items: center; gap: 16px;
  padding: 20px; margin-bottom: 16px;
}
.stu-avatar-wrap {
  width: 56px; height: 56px; border-radius: 50%;
  background: linear-gradient(135deg, #00ab84, #00d4aa);
  display: flex; align-items: center; justify-content: center;
  color: #fff; font-size: 24px; font-weight: bold; flex-shrink: 0;
}
.stu-profile-info h3 { margin: 0 0 4px; font-size: 18px; color: #303133; }
.stu-profile-info .stu-class-tag {
  display: inline-block; padding: 2px 10px; border-radius: 10px;
  font-size: 12px; color: #fff; margin-right: 6px; margin-top: 2px;
}
.stu-profile-info .stu-room-tag {
  display: inline-block; padding: 2px 10px; border-radius: 10px;
  font-size: 12px; color: #606266; background: #f0f2f5; margin-top: 2px;
}

.stu-shortcuts {
  display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px;
  margin-bottom: 16px;
}
.stu-shortcut-item {
  display: flex; flex-direction: column; align-items: center; gap: 8px;
  padding: 16px 8px; background: #fff; border-radius: 12px;
  cursor: pointer; transition: all .2s;
  box-shadow: 0 1px 4px rgba(0,0,0,.06);
}
.stu-shortcut-item:active { transform: scale(.96); }
.stu-shortcut-icon {
  width: 44px; height: 44px; border-radius: 12px;
  display: flex; align-items: center; justify-content: center;
  font-size: 22px; color: #fff;
}
.stu-shortcut-label { font-size: 13px; color: #606266; }

.stu-notice-card, .stu-reminder-card { margin-bottom: 16px; }
.stu-card-title {
  display: flex; align-items: center; gap: 8px;
  font-size: 15px; font-weight: 600; color: #303133; margin-bottom: 12px;
}
.stu-card-title .el-icon { font-size: 18px; }

.stu-notice-item {
  display: flex; justify-content: space-between; align-items: center;
  padding: 10px 0; border-bottom: 1px solid #f2f3f5;
  cursor: pointer;
}
.stu-notice-item:last-child { border-bottom: none; }
.stu-notice-title { font-size: 14px; color: #303133; flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.stu-notice-time { font-size: 12px; color: #909399; margin-left: 8px; flex-shrink: 0; }

.stu-empty { text-align: center; padding: 20px; color: #909399; font-size: 14px; }

.stu-reminder-item {
  display: flex; align-items: center; gap: 10px;
  padding: 8px 0; font-size: 14px;
}
.stu-reminder-class {
  padding: 2px 8px; border-radius: 4px; font-size: 12px; color: #fff;
}
.stu-reminder-count { color: #303133; }
.stu-reminder-date { font-size: 12px; color: #909399; margin-left: auto; }

@media screen and (min-width: 769px) {
  .stu-home { padding: 0 20px; max-width: 600px; margin: 0 auto; }
}
</style>
